import fetchJson from '@atlassian/jira-issue-reliability-fetch/src/issue-view-as-json.tsx';
import { getCmdbGlobalConfigUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/global.tsx';

type ReturnType = {
	restrictedObjectSchemaIds: number[];
};

export const fetchReadOnlySchemaId = async (workspaceId: string): Promise<number> => {
	const url = getCmdbGlobalConfigUrl(workspaceId);

	const result: ReturnType = await fetchJson(
		url,
		{},
		'fields/service-entity/src/services/fetch-object-details/fetch-read-only-schema-id',
	);

	const { restrictedObjectSchemaIds } = result;

	if (restrictedObjectSchemaIds.length !== 1) {
		throw new Error('Could not find readonly schema.');
	}

	return restrictedObjectSchemaIds[0];
};
